import ManagerList from '../../ManagerList';

export default function ManagersUsersPage() {
  return (
    <ManagerList />
  );
};

